import { render, staticRenderFns } from "./SelectButton.vue?vue&type=template&id=8a6d437e&scoped=true"
import script from "./SelectButton.vue?vue&type=script&lang=js"
export * from "./SelectButton.vue?vue&type=script&lang=js"
import style0 from "./SelectButton.vue?vue&type=style&index=0&id=8a6d437e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6d437e",
  null
  
)

/* custom blocks */
import block0 from "./SelectButton.vue?vue&type=custom&index=0&blockType=select-button&%3AbuttonData=buttonData&%40buttonClick=buttonClick"
if (typeof block0 === 'function') block0(component)

export default component.exports